module.exports = __webpack_public_path__ + "images/morganc5bee4232a51aa739e24ceb883cdf206.png";